exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".input-group .form-control[_v-a81ff0c2]{font-family:Open Sans;font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-a81ff0c2&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/pages/Admin/Admin-slider.vue
// module id = 452
// module chunks = 0